import countryPhoneCodes from "~/js/modules/country-phone-codes";
import CustomRecaptcha from "~/js/components/form-controls/CustomRecaptcha";
import "~/js/libs/jquery-ui.selectmenu.min.js";
import "slick-carousel";
import "~/js/libs/jquery.waypoint";
import "~/js/libs/sticky";

// Variable Declaration
const resortMenu = document.getElementById("resort-menu");
const toggleButton = document.getElementById("resort-menu-click");
const isFixedNav = resortMenu.classList.contains("fixed-resort-menu");
let waypoint;

// Internals Variables
const internals = {
  options: {
    element: resortMenu,
    offset: 0,
    stuckClass: "stuck",
  },
};

// Sticky Nav
if (!isFixedNav) {
  waypoint = new window.Waypoint.Sticky(internals.options);
}

// Toggle Sticky Nav
toggleButton.addEventListener("click", () =>
  resortMenu.classList.toggle("open")
);
document.body.addEventListener("click", (event) => {
  if (
    $(event.target).parents("#resort-menu").length <= 0 &&
    resortMenu.classList.contains("open")
  ) {
    resortMenu.classList.remove("open");
  }
});

const stickyNav = _globalUtils.debounce(() => {
  if (window.pageYOffset <= waypoint.waypoint.triggerPoint) {
    if (window.innerWidth > 767) {
      if (resortMenu.classList.contains("stuck")) {
        resortMenu.classList.remove("stuck");
      }
    }
  }
}, 300);

window.addEventListener("resize", stickyNav);

////////////////End of Sticky Nav//////////////////////

ReactDOM.render(
  <CustomRecaptcha wrapperClassName="xs-12 lg-12" />,
  document.getElementById("google-recaptcha")
);

/////////////// Area code + country name -> Show/hide SMS /////////////

const countryCodes = countryPhoneCodes.map(
  (element) => `${element.dial_code} - ${element.name}`
);
const selectElement = document.getElementById("areaCode");

countryCodes.forEach((element) => {
  let dialCode = element.split(" -");
  selectElement.add(new Option(element, dialCode[0]));
});

const selectElement2 = document.getElementById("areaCode");
const countryNameField = document.getElementById("country");

selectElement2.addEventListener("change", function (event) {
  const smsProp = document.querySelector(".sms");
  let selectedCountry = event.target.options[event.target.selectedIndex].text
  let splitCountry = selectedCountry.split(" -");
  let pais = splitCountry[1];
  
  let sendcountryCode = countryPhoneCodes.filter(x => x.name.toLowerCase() == pais.trim().toLowerCase());
    countryNameField.value = sendcountryCode[0].code;

    if (countryNameField.value == 'US') {
      smsProp.classList.remove("hideSms");
      smsProp.classList.add("showSms");
    } 
    else if (countryNameField.value !== 'US') {
      smsProp.classList.add("hideSms");
      smsProp.classList.remove("showSms");

      if(smsCheckBox.checked === true){
        smsCheckBox.checked = false;
      }
    }
}); 


// Form validations
import "~/js/modules/fend";

const $inquiryForm = $(".inquiry-registration-form");
const $submitButton = $(".form-submit-button");
const $suscribeCheckbox = $("#subscribe");
const $suscribeHidden = $("#subscribeHidden");

$submitButton.click(() => {
  $("[name=phoneNumber]").val($("[name=mobileNumber]").val());

  if ($suscribeCheckbox.is(":checked") === true) {
    $suscribeHidden.prop("disabled", true);
  } else {
    $suscribeHidden.prop("disabled", false);
  }
});

$inquiryForm.fend({
  rules: {
    firstName: "lettersOnly",
    lastName: "lettersOnly",
    phoneNumber: "number",
  },
  isMultiPart: false,
});
